module.exports = __webpack_public_path__ + "static/media/checkedicon.cd204dd1.svg";